import { Unext } from '@/types/api/mypage/options';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * U-NEXTオプション情報を保持する state。
 * 利用状態、開始日、変更可否、解約可否をまとめて持ち、申込変更・解約画面の基礎データにする。
 */
export const unextOptionInfoState = atom<Unext>({
  key: 'UnextOptionInfoState',
  default: {
    use_status: '',
    status_code: '',
    start_date: '',
    plan: '',
    program_guide: '',
    is_changeable: false,
    is_quitable: false,
    has_campaign: false,
  },
  effects_UNSTABLE: [persistAtom],
});

export default unextOptionInfoState;
